// Navigation

'use strict';

$('#menu-toggle').click(function () {
    var $body = $('body'),
        $menu = $('.nav-container'),
        $hamburger = $('.hamburger');
    $body.toggleClass('menu-open')
    if ($body.hasClass('menu-open')) {
        $menu.addClass('menu-active');
        $hamburger.addClass('is-active');
    } else {
        $menu.removeClass('menu-active');
        $hamburger.removeClass('is-active');
    }
});

// Navigation If we have submenu


// Tabset Tabs
function changeTabsetTab(_el, id) {

    _el.on('click',

        function (e) {

            let parentEl = $(this).closest('.element');

            e.preventDefault()

            if ($(this).hasClass('active')) {
                return
            }

            let _tab = parentEl.find(`[aria-labelledby='${id}']`);
            parentEl.find('.tab-content .tab-pane').toArray().forEach(function (el) {
                $(el).removeClass('active').removeClass('show');
            })

            parentEl.find('.nav-tabs li').toArray().forEach(function (el) {
                $(el).removeClass('active').removeClass('show');
            })

            _tab.addClass('active show');

            _el.addClass('active');

            _tab.find('.tab-pane').addClass('active show');

        });
}

// Slider

function updateSlide(state, slides) {

    const _dots = document.querySelector(".sliders-dot");
    let _sl = Array.from(slides.children);

    let _updateDot = function (__action, element) {
        const _class_list = Array.from(element.classList);
        let _matches = _class_list.filter(word => word.match(new RegExp('[0-9]+', 'g')));

        if (_matches[0]) {
            const _id = parseInt(_matches[0].split('slide-item-')[1]);
            const _current_dot = document.querySelector('.slide-dot-' + _id);

            if (__action === 'remove') {
                _current_dot.classList.remove('active');
            }

            if (__action === 'add') {
                _current_dot.classList.add('active');
            }
        }
    }


    _sl.forEach((element, index) => {

        if (element.classList.contains('active')) {
            element.classList.remove('active');
            _updateDot('remove', element)

        }

        if (state == index) {
            element.classList.add('active')
            _updateDot('add', element)
        }

    })
}

let myMap;
let clubsMap;

function makeMap() {
    myMap = L.map('map').setView([-43.4320, 172.6306], 10);

    let myFeatureGroup = L.featureGroup().addTo(myMap).on('click', showDirections);

    L.tileLayer('https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a> hosted by <a href="https://openstreetmap.fr/" target="_blank">OpenStreetMap France</a>'
    }).addTo(myMap);

    let locations = Array.from($('#map .venue-location'));

    let redMarker = new L.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
    });

    $(locations).each(function () {
        let location = $(this).attr('data-class');
        let marker = L.marker([$(this).attr('data-lat'), $(this).attr('data-long')], {icon: redMarker}).addTo(myFeatureGroup);
        marker.location = location;
    });

    let $southWest = L.latLng(-52.02545860348813, 158.0712890625),
        $northEast = L.latLng(-30.939924331023455, 189.44824218750003);

    let $bounds = L.latLngBounds($southWest, $northEast);

    myMap.setMaxBounds($bounds);
    myMap.setMinZoom(5);
}

function makeClubsMap() {
    clubsMap = L.map('clubs-map').setView([-43.4320, 172.6306], 10);

    let myFeatureGroup = L.featureGroup().addTo(clubsMap).on('click', showClubDirections);

    L.tileLayer('https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a> hosted by <a href="https://openstreetmap.fr/" target="_blank">OpenStreetMap France</a>'
    }).addTo(clubsMap);

    let locations = Array.from($('#clubs-map .venue-location'));

    $(locations).each(function () {
        let location = $(this).attr('data-class');
        let marker = L.marker([$(this).attr('data-lat'), $(this).attr('data-long')]).addTo(myFeatureGroup);
        marker.location = location;
    });

    let $southWest = L.latLng(-52.02545860348813, 158.0712890625),
        $northEast = L.latLng(-30.939924331023455, 189.44824218750003);

    let $bounds = L.latLngBounds($southWest, $northEast);

    clubsMap.setMaxBounds($bounds);
    clubsMap.setMinZoom(5);
}

function showDirections(event) {
    grabLocations(event);
    myMap.flyTo([event.layer.getLatLng().lat, event.layer.getLatLng().lng], 13)
}

function showClubDirections(event) {
    grabLocations(event);
    clubsMap.flyTo([event.layer.getLatLng().lat, event.layer.getLatLng().lng], 13)
}

function grabLocations(event) {
    let locations = Array.from($('.venue-location-container'));

    $(locations).each(function () {
        if ($(this).hasClass(event.layer.location) && !$(this).hasClass('active')) {
            $(this).addClass('active')
        } else if (!$(this).hasClass(event.layer.location) && $(this).hasClass('active')) {
            $(this).removeClass('active');
        }
    });
}

$(document).ready(function () {
    if ($('#map').length) {
        makeMap();
    }

    if ($('#clubs-map').length) {
        makeClubsMap();
    }

    // Close AD
    let _btn_close = $('.AD__button--close');

    _btn_close.on('click', function (e) {
        e.preventDefault();
        const _AD = $(this).parent();

        console.log(_AD);

        _AD.css({'display': 'none'});

        const _menu = $('.header-principal');
        _menu.css({'margin-top': '0'});

        if($('.blocks__bannervideoblock').length) {
            const _header = $('.blocks__bannervideoblock');
            _header.css({'margin-top': '0'});
        }

        const _header_nav = $('div.header-wrapper');
        _header_nav.css({'margin-top': '0'});
    });

    // Initial Scripts Tabs
    const tabset_nav_items = $('.tabset').find('.nav-tabs li').toArray();

    tabset_nav_items.forEach(function (_el, index) {

        if ($(_el).find('.active').hasClass('active')) {
            $(_el).addClass('active')
        }
        return changeTabsetTab($(_el), $(_el).children().attr('id'));
    });

    // Header Main Desktop
    const _clean = function () {

        const submenu_opened = $('.nav-primary').find('.nav-item');

        submenu_opened.each(function (index, item) {
            let e = $(item).find('.opened');
            if (e.length > 0) {
                e.removeClass('opened')
            } else {
                return
            }
        })
    }

    // Hidden Main if there is not an ancester with has_children as class

    window.addEventListener('click', (e) => {
        let _target = $(e.target);

        if (!_target.closest('.has_children').length && $('.nav-secondary').hasClass("opened")) {
            _clean()
        }
    });

    $('.nav-item a.has_children').on('click', function (e) {
        if ($('#navigator.menu-active').length) {
            if (!$(this).hasClass('opened')) {
                e.preventDefault()

                _clean()

                $(this).toggleClass('opened');

                const _submenu = $(this).siblings('.nav-secondary');

                if (_submenu.hasClass('opened')) {
                    _submenu.removeClass('opened')
                } else {
                    _submenu.addClass('opened')
                }

                let otherArrows = $('a.has_children i');

                otherArrows.each(function () {
                    if ($(this).hasClass('rotate')) {
                        $(this).toggleClass('rotate');
                    }
                });

                $(this).children('i').toggleClass('rotate');
            }
        }
    });

    // if ($('.menu-open').length) {
    //     $('.nav-item a.has_children').on('click', function (e) {
    //         e.preventDefault()
    //         _clean()
    //         const _submenu = $(this).siblings('.nav-secondary');
    //
    //         if (_submenu.hasClass('opened')) {
    //             _submenu.removeClass('opened')
    //         } else {
    //             _submenu.addClass('opened')
    //         }
    //     });
    // }

    // Slider Home Page.

    const _btn_slider_left = $(".slider__button-left");
    const _btn_slider_right = $(".slider__button-right");
    const _slider_list = $(".block__news");
    let _slide_index = 0;


    if (_btn_slider_right && _btn_slider_right) {
        _btn_slider_right.on("click", function () {

            _slide_index++

            if (_slide_index >= _slider_list.children.length) {
                _slide_index = 0;
            }

            updateSlide(_slide_index, _slider_list);
        })

        _btn_slider_left.on("click", function () {

            _slide_index--

            if (_slide_index < 0) {
                _slide_index = _slider_list.children.length - 1;
            }

            updateSlide(_slide_index, _slider_list);
        })

    }

    // Categories Menu

    if ($('.container__news-and-events-categories')) {

        $('.active-zone').on('click', function () {
            $(this).parent('ul').toggleClass('active')
        })

        const $categories = $('.container__news-and-events-categories ul li a');
        const $textMobile = $('.mobile-cat');

        $categories.each(function (index, item) {
            if ($(item).hasClass('current-category')) {
                $textMobile.html($(item).text());
            }
        })
    }

    // Lightbox Directors and Staff

    // const staff = $('.team-member');
    //
    // staff.each(function (index, member) {
    //
    //     const ID = $(member).attr('data-team-member-id');
    //
    //     $($(member).find('.open-long-description')).modaal({
    //         content_source: '#longDescription-' + ID
    //     })
    // });

    const faqs = $('.faq');

    faqs.each(function () {
        $(this).removeClass('unfold');
        $(this).children('.faq-item').hide();
    });

    faqs.on('click', function () {
        $(this).siblings('.unfold').trigger('click')

        let $faqContent = $(this).children('.faq-item');
        $(this).toggleClass('unfold')

        if ($(this).hasClass('unfold')) {
            $faqContent.show()
            let height = $faqContent.height()
            $faqContent.height(0).height(height)
            window.setTimeout(function () {
                $faqContent.height('')
            }, 250)
        } else {
            let height = $faqContent.height()
            $faqContent.height(height).height(0)
            window.setTimeout(function () {
                $faqContent.hide().height('')
            }, 250)
        }

    });

    const tabset = $('.tabset-container');
    const tabContent = tabset.children($('.tab-content'));
    const navItems = tabset.children($('.nav.nav-tabs').children($('.nav-item')));

    navItems.each(function () {
        $(this).click(function () {
            if ($(window).width() + 15 <= 1600) {
                var scrollAmount = tabContent.offset().top - $(window).scrollTop();

                $('html, body').animate({
                    scrollTop: '+=' + scrollAmount
                }, 600);
            }
        });
    });

    // function handleScrollOnResize() {
    //
    //     if ($(window).width() + 15 <= 1600) {
    //         var scrollAmount = tabContent.offset().top - $(window).scrollTop();
    //         $('html, body').animate({
    //             scrollTop: '+=' + scrollAmount
    //         }, 600);
    //     }
    // }
    //
    // $(window).resize(handleScrollOnResize);

// Change Recaptcha error message
    if ($('.field.nocaptcha .message.error').length) {
        changeErrMsg();
    }
});

function changeErrMsg() {
    let targetParent = $('.nocaptcha')
    let target;

    if (targetParent.children('.message.error').length) {
        let target = targetParent.children('.message.error');
        target.text('Verification failed. Please try to verify again.');
    }
}
